/**
 * This agent's custom surface components — the client half of the agent's
 * catalog (server half: `agent-dev-server/src/surfaces/`). Each entry maps a
 * `ComponentContract.component` name to its React realization.
 */
import type { FC } from 'react';
import type { A2uiNodeViewProps } from '@/app/lib/a2ui/catalog.tsx';
import { SourcingHome } from './SourcingHome.tsx';
import { BriefPanel } from './BriefPanel.tsx';
import { ProcurementBrief } from './ProcurementBrief.tsx';
import { SupplierShortlist } from './SupplierShortlist.tsx';
import { SupplierComparison } from './SupplierComparison.tsx';
import { ProcurementRequest } from './ProcurementRequest.tsx';
import { ProcurementSuccess } from './ProcurementSuccess.tsx';

export const AGENT_SURFACE_COMPONENTS: Record<string, FC<A2uiNodeViewProps>> = {
  SourcingHome,
  BriefPanel,
  ProcurementBrief,
  SupplierShortlist,
  SupplierComparison,
  ProcurementRequest,
  ProcurementSuccess,
};
